export enum EventCategory {
  WORKSHOP = 'workshop',
  SURVEY = 'survey',
  UNKNOWN = 'unknown',
}

export enum EventStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  ALL = 'all',
}

export enum UserRegistrationStatus {
  SIGNED_UP = 'signed_up',
  WAITLISTED = 'waitlisted',
}

export enum ResidencePlace {
  URBAN = 'Stadtumgebung',
  RURAL = 'Ländlich',
  UNSPECIFIED = 'Keine Angabe',
}

export enum SalutationStatus {
  MR = 'Herr',
  MS = 'Frau',
  MX = 'Divers',
}

export type ProfileExtension = {
  key:
    | 'bestandskunde'
    | 'produkte'
    | 'online-dienste-we'
    | 'internet-nutzung'
    | 'online-affinitaet'
    | 'personafrage'
    | 'teilnahmebedingungen';
  value: string[];
};

export function stringToSalutationStatus(value: string): SalutationStatus | undefined {
  return Object.values(SalutationStatus).find(v => v === value);
}

export function isRelevantCategory(category: EventCategory): boolean {
  return category === EventCategory.WORKSHOP || category === EventCategory.SURVEY;
}

export interface IUserInterestsProfile {
  id: string;
  salutation: SalutationStatus;
  firstName: string;
  lastName: string;
  email: string;
  telefonCountryCode: string;
  telefonNumber: string;
  birthyear: string;
  placeOfResidence: ResidencePlace;
  valid: boolean;
  profileExtension: ProfileExtension[];
}

export interface CommunityEvent {
  id: string;
  status: EventStatus;
  category: EventCategory;
  title: string;
  description: string;
  shortDescription: string;
  location: string;
  startTime: string;
  endTime: string;
  address: CommunityAddress;
  maxParticipants: number;
  registeredParticipants: number;
  waitingParticipants: number;
  userRegistrationStatus: UserRegistrationStatus;
  fullyBooked: boolean;
}

// TODO: For some reason, this is different to Address
export interface CommunityAddress {
  street: string;
  houseNumber: string;
  addressAddition: string;
  staircase: string;
  doorNumber: string;
  roomNumber: string;
  floor: string;
  postalCode: string;
  city: string;
  state: string;
}
